import React, { useEffect } from "react";
import { useState } from "react";
import { Table, Button, Popover, OverlayTrigger } from "react-bootstrap";
import { fetchAllUser } from "../../service/UserService";
import { fetchAllPost } from "../../service/postsService";
import { Edit, Eye, Trash } from "lucide-react";

const CommentList = ({ comment, onEdit, onDelete, onView }) => {
  const [users, setUsers] = useState([]);
  const [posts, setPosts] = useState([]);

     const loadUsers = async () => {
        try {
          const res =await fetchAllUser();
          
          setUsers(res);
        } catch (error) {
          console.error("Error in Fetch");
        }
  }
  const loadPosts = async () => {
      try {
        const res = await fetchAllPost();
  
        setPosts(res);
      } catch (error) {
        console.error("Error in Fetch");
      }
  };
  
  useEffect(() => {
    loadUsers();
    loadPosts();
  }, [])
  const viewPopover = (
    <Popover id="popover-view">
      <Popover.Body>View Comment details</Popover.Body>
    </Popover>
  );
  const editPopover = (
    <Popover id="popover-view">
      <Popover.Body>Edit Comment details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-view">
      <Popover.Body>Delete Comment </Popover.Body>
    </Popover>
  );
  return (
    <Table className="custom-employee-table" bordered hover responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Post Title</th>
          <th>UserName</th>
          <th>Content</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {comment.length > 0 ? (
          comment.map((com, idx) => {
            const matchedUser = users.find((user) => user.userId === com.userId);
            const matchedPost = posts.find((post) => post.postId === com.postId);
            return (
              <tr key={com.commentId}>
                <td>{idx + 1}</td>
                <td>{matchedPost.title || "NA"}</td>
                <td>{matchedUser.username || "NA"}</td>
                <td>{com.content}</td>

                <td>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={viewPopover}
                  >
                    <Button
                      size="sm"
                      className="me-1"
                      style={{
                        backgroundColor: "#10296C",
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => onView(com)}
                    >
                      <Eye />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={editPopover}
                  >
                    <Button
                      size="sm"
                      variant="warning"
                      style={{
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      className="me-1"
                      onClick={() => onEdit(com)}
                    >
                      <Edit />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={deletePopover}
                  >
                    <Button
                      size="sm"
                      variant="danger"
                      style={{
                
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => onDelete(com.commentId)}
                    >
                      <Trash />
                    </Button>
                  </OverlayTrigger>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="6" className="text-center">
              Not found.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default CommentList;
